export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назва:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Будь ласка, вкажіть нову назву для активу"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ця назва допоможе вам легше ідентифікувати гаманець у списку активів."])}
}